import { AdditionalNoticeType } from "../../../../__generated__/gql/graphql";

// チケット予約の注意事項
// https://www.notion.so/sanu/b2e57f3070134a99b06f0cfd114f1163?pvs=4#114d14f248a880e4be28ca64c71a9266
// `type` が指定されている場合は、そのタイプを含むマスターの時のみ表示される。
// `type` が `undefined` の時は、マスターによらず必ず表示される。
const additionalNoticeMessages: {
  text: string;
  type: AdditionalNoticeType | undefined;
}[] = [
  {
    text: "拠点までの交通費は含まれません。あらかじめご了承ください。",
    type: undefined,
  },
  {
    text: "本チケットを第三者への譲渡や現金との引き換えはできません。",
    type: undefined,
  },
  {
    text: "チェックイン日当日の予約を取ることができるのは15時より前までです。",
    type: undefined,
  },
  {
    text: "本チケットは、SANU 2nd Homeのメンバー（以下「メンバー」）の家族・知人・友人（以下「メンバー友人」）に直接付与された場合に限り有効です。",
    type: AdditionalNoticeType.Transfer,
  },
  {
    text: "メンバー及びメンバー友人から第三者への譲渡（以下「第三者譲渡」）を固く禁じます。",
    type: AdditionalNoticeType.Transfer,
  },
  {
    text: "本チケットのオークションサイト・フリマアプリ等への出品を固く禁じます。",
    type: AdditionalNoticeType.Transfer,
  },
  {
    text: "第三者譲渡されたチケット並びにオークションサイトやフリマサイトなどで購入されたチケットについては、判明した時点でチケットの利用は停止されます。また、返金も承っておりません。",
    type: AdditionalNoticeType.Transfer,
  },
  {
    text: "購入したチケットの払戻しは原則としてできません。ただし、当社が当チケットによる宿泊サービス提供を終了する場合、その他当社が認めた場合に限り払戻しをいたします。",
    type: AdditionalNoticeType.Refund,
  },
];

export function AdditionalNoticeArea({
  additionalNoticeTypes,
}: {
  additionalNoticeTypes: AdditionalNoticeType[];
}) {
  const filteredAdditionalNoticeMessages = additionalNoticeMessages.filter(
    ({ type }) => type === undefined || additionalNoticeTypes.includes(type),
  );

  if (filteredAdditionalNoticeMessages.length === 0) {
    return null;
  }

  return (
    <div className="mt-4 text-[12px]">
      <h3 className="font-bold">注意事項</h3>
      <ul className="mt-2">
        {filteredAdditionalNoticeMessages.map(({ text }, index) => (
          <li
            key={index}
            className="ml-[2em] before:ml-[-1.5em] before:pr-[0.5em] before:content-['※']"
          >
            {text}
          </li>
        ))}
      </ul>
    </div>
  );
}
